import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  reauthenticateWithCredential, 
  EmailAuthProvider, 
  GoogleAuthProvider,
  reauthenticateWithPopup
} from "firebase/auth";
import { auth } from './firebase';
import { useAuth } from './AuthContext';
import { 
  FiAlertCircle, 
  FiShield, 
  FiArrowLeft,
  FiCheck 
} from 'react-icons/fi';
import { FaGoogle } from 'react-icons/fa';
import './auth-pages.css';

function ReauthenticatePage() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { setReauthenticationStatus, nextPageAfterReauth } = useAuth();

  const handleEmailReauth = async (event) => {
    event.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const credential = EmailAuthProvider.credential(
        auth.currentUser.email,
        password
      );
      
      await reauthenticateWithCredential(auth.currentUser, credential);
      setReauthenticationStatus(true);
      navigate(nextPageAfterReauth || '/dashboard/profile');
    } catch (error) {
      setError('Authentication failed: ' + (error.message || 'Please check your password'));
      setIsLoading(false);
    }
  };

  const handleGoogleReauth = async () => {
    setError('');
    setIsLoading(true);
    
    try {
      const provider = new GoogleAuthProvider();
      await reauthenticateWithPopup(auth.currentUser, provider);
      setReauthenticationStatus(true);
      navigate(nextPageAfterReauth || '/dashboard/profile');
    } catch (error) {
      setError('Authentication failed: ' + (error.message || 'Google sign-in failed'));
      setIsLoading(false);
    }
  };

  const isGoogleUser = auth.currentUser?.providerData.some(
    provider => provider.providerId === 'google.com'
  );

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Verify Your Identity</h1>
          <p>For security reasons, please confirm your password</p>
        </div>

        {error && (
          <div className="auth-error">
            <FiAlertCircle />
            <span>{error}</span>
          </div>
        )}

        <div className="auth-warning" style={{ marginBottom: '1.5rem' }}>
          <FiShield />
          <span>
            This action requires recent authentication. Please verify your identity to continue.
          </span>
        </div>

        {isGoogleUser ? (
          <button 
            className="auth-btn google-btn" 
            onClick={handleGoogleReauth}
            disabled={isLoading}
          >
            <FaGoogle /> {isLoading ? 'Verifying...' : 'Verify with Google'}
          </button>
        ) : (
          <form className="auth-form" onSubmit={handleEmailReauth}>
            <div className="form-group">
              <input
                type="password"
                className="form-control"
                placeholder="Your Current Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button 
              type="submit" 
              className="auth-btn primary-btn"
              disabled={isLoading}
            >
              <FiCheck /> {isLoading ? 'Verifying...' : 'Verify Password'}
            </button>
          </form>
        )}

        <button 
          className="auth-btn secondary-btn" 
          onClick={() => navigate('/dashboard/profile')}
          disabled={isLoading}
        >
          <FiArrowLeft /> Back to Profile
        </button>
      </div>
    </div>
  );
}

export default ReauthenticatePage;